module.exports = __webpack_public_path__ + "static/media/hidrogeno verde transporte de carga.1afabb6d.jpg";